<style lang="scss" scoped>
.camera {
  width: 415px;
  height: 256px;
  margin-top: 20px;

  .plane {
    // padding-top: 5px;

    .park_space {
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      div {
        width: 142px;
        height: 142px;
      }
    }
  }
}
</style>

<template>
  <div class="camera">
    <custom-plane
      title="停车管理"
      class="plane"
      :iconImg="require('@/assets/compImg/icon/parking.png')"
    >
      <div class="park_space">
        <div>
          <custom-progress-circle
            :title="'停车位'"
            :text="text1"
            :value="value1"
            color="#2D82FF"
          ></custom-progress-circle>
        </div>
        <div>
          <custom-progress-circle
            :title="'道闸'"
            :text="text2"
            :value="value2"
            color="#F1802F"
          ></custom-progress-circle>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  props: {
    text1: String,
    text2: String,
  },
  computed: {
    value1() {
      return (
        (Number(this.text1.split("/")[0]) / Number(this.text1.split("/")[1])) *
        100
      );
    },
    value2() {
      return (
        (Number(this.text2.split("/")[0]) / Number(this.text2.split("/")[1])) *
        100
      );
    },
  },
};
</script>
